import { render, staticRenderFns } from "./Bubbles.vue?vue&type=template&id=738ad205&"
import script from "./Bubbles.vue?vue&type=script&lang=js&"
export * from "./Bubbles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports